export const SET_LOGIN_INFO = 'SET_LOGIN_INFO';
export const FETCH_LOGIN = 'FETCH_LOGIN';
export const SET_COUPON_SELECTED = 'SET_COUPON_SELECTED';
export const SET_PAY_GLOBAL = 'SET_PAY_GLOBAL';
export const CHANGE_COUPON_SELECTED = 'CHANGE_COUPON_SELECTED';
export const CHANGE_PAY_GLOBAL = 'CHANGE_PAY_GLOBAL';
export const FETCH_UP_RELATION = 'FETCH_UP_RELATION';
export const CHANGE_UP_RELATION = 'CHANGE_UP_RELATION';
export const SET_UP_RELATION = 'SET_UP_RELATION';
export const TRIGGER_FOLLOW = 'TRIGGER_FOLLOW';
export const SET_FOLLOW_STAT = 'SET_FOLLOW_STAT';
export const UPDATE_FOLLOW_STATUS = 'UPDATE_FOLLOW_STATUS';
export const SET_FOLLOW_STATUS = 'SET_FOLLOW_STATUS';